module.exports = __webpack_public_path__ + "static/pic02-cc4a61d71b2fb6f2ccfa1383f3ecaf0b.jpg";